// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.700a32846',
  revision: '700a32846',
  branch: 'develop',
  date: 'Thu, 24 Sep 2026 07:00:41 GMT'
};